module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.order != null) ? _c('section', {
    staticClass: "my-order col-md-12"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (_vm.order.status.reference_status === 'order_deleted') ? _c('div', {
    staticClass: "orderDeleted"
  }, [_c('OrderDeleted', {
    attrs: {
      "orderData": _vm.order
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.status.reference_status !== 'order_deleted'),
      expression: "order.status.reference_status !== 'order_deleted'"
    }]
  }, [(_vm.order.status) ? _c('div', {
    staticClass: "order-status"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t("orders.labelStatus")) + " :")]), _vm._v(" "), _c('span', {
    staticClass: "status"
  }, [_c('i', {
    staticClass: "fas fa-file-invoice-dollar"
  }), _vm._v(" " + _vm._s(_vm.getTranslate(_vm.order.status.name)))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 my-order-header"
  }, [_c('order-header', {
    staticClass: "my-order-header"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-order-list col-lg-9 col-md-8 col-xs-12"
  }, [_c('OrderMain', {
    attrs: {
      "orderData": _vm.order
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "my-order-recap col-lg-3 col-md-4 col-xs-12"
  }, [_c('orderSideBloc', {
    attrs: {
      "title": _vm.$t('orders.deliveryAddress.title')
    }
  }, [_c('delivery-address', {
    key: _vm.order.id,
    attrs: {
      "dataDeliveryAdress": _vm.order
    }
  })], 1), _vm._v(" "), (_vm.havePaymentRights) ? _c('orderSideBloc', {
    attrs: {
      "title": _vm.$t('orders.payments.title')
    }
  }, [_c('order-payments', {
    key: _vm.order.id,
    attrs: {
      "dataPurchaseOrderNumber": _vm.order.purchaseOrderNumber
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('orderSideBloc', {
    attrs: {
      "title": _vm.$t('orders.orderWindow.title')
    }
  }, [_c('orderWindows')], 1)], 1)])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e4c9c02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orders/myOrder.vue
// module id = 3014
// module chunks = 0